
import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ContactSection from '../components/ContactSection';

const ContactPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <div className="pt-16 md:pt-24 bg-swastik-lightBlue/10">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl md:text-5xl font-bold text-swastik-blue font-serif mb-6">Contact Us</h1>
          <div className="flex flex-wrap gap-2 mb-8">
            <a href="/" className="text-swastik-blue hover:text-swastik-blue/70">Home</a>
            <span className="text-gray-400">/</span>
            <span className="text-gray-600">Contact</span>
          </div>
        </div>
      </div>
      
      <ContactSection />
      
      <section className="py-16 md:py-24 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center max-w-3xl mx-auto mb-16">
            <span className="text-swastik-green font-medium">Frequently Asked</span>
            <h2 className="section-title mx-auto after:left-1/2 after:-translate-x-1/2">Common Questions</h2>
            <p className="section-subtitle">
              Have questions about our services or treatments? Here are some quick answers to our most commonly asked questions.
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 gap-6">
            <div className="bg-gray-50 p-6 rounded-lg border border-gray-100">
              <h3 className="text-xl font-bold text-swastik-blue mb-3">Do you offer online consultations?</h3>
              <p className="text-gray-600">
                Yes, we provide telemedicine consultations for patients who cannot visit our facility. However, for comprehensive treatment, we recommend at least one in-person visit.
              </p>
            </div>
            
            <div className="bg-gray-50 p-6 rounded-lg border border-gray-100">
              <h3 className="text-xl font-bold text-swastik-blue mb-3">How long does the treatment typically take?</h3>
              <p className="text-gray-600">
                Treatment duration varies depending on the condition and its severity. Most chronic conditions show improvement within 3-6 months of consistent treatment.
              </p>
            </div>
            
            <div className="bg-gray-50 p-6 rounded-lg border border-gray-100">
              <h3 className="text-xl font-bold text-swastik-blue mb-3">Are your medications safe to take with other prescriptions?</h3>
              <p className="text-gray-600">
                While our herbal medicines are generally safe, we always recommend disclosing all current medications during consultation to avoid potential interactions.
              </p>
            </div>
            
            <div className="bg-gray-50 p-6 rounded-lg border border-gray-100">
              <h3 className="text-xl font-bold text-swastik-blue mb-3">Do you have accommodation facilities?</h3>
              <p className="text-gray-600">
                Yes, we provide comfortable accommodation for patients who require residential treatment programs or are traveling from other cities.
              </p>
            </div>
          </div>
        </div>
      </section>
      
      <Footer />
    </div>
  );
};

export default ContactPage;
